import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-department-lang',
  templateUrl: './department-lang.component.html',
  styleUrls: ['./department-lang.component.css']
})
export class DepartmentLangComponent implements OnInit {
    departmentId;

    public inputListLanguages: InputLanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.departmentId = this.stateService.getStateParams()['department_id'];
    }

    private async loadLanguages(): Promise<void> {
        this.inputListLanguages = await this.datatask.Post(2231, { department_id: this.departmentId });
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2232, { records: this.inputListLanguages }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface InputLanguageItem {
    department_id: number;
    department_lang_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('departmentLang', {
//        templateUrl: 'views/components/views/departmentLang/departmentLang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'departmentLangService', function ($stateParams, stateService, modalService, translateService, departmentLangService) {
//            const vm = this;
//            let departmentId = $stateParams.department_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await departmentLangService.listDepartmentLang({ department_id: departmentId });
//            }

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                departmentLangService.saveObj({ records: vm.model.inputListLanguages }).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            vm.$onInit = function () {
//                translate();
//                loadLanguages();
//            };
//        }]
//    });
//})();
